import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";
import { authGuard } from './shared/guard/auth.guard';

const routes: Routes = [
  {
    path: "",
    redirectTo: "account",
    pathMatch: "full",
  },
  {
    path: "account",
    loadChildren: () => import("../app/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [authGuard],
    children: content,
  },
  // {
  //   path: "",
  //   component: ContentComponent,
  //   children: content

  // },
  // {
  //   path: 'invalid-link',
  //   component: LoginComponent,
  // },
  
  {
    path: "**",
    redirectTo: "account",
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
